import { toast } from "react-toastify";
import { store } from "../../../../redux/store";
import {
  setAllCompleted
} from "../../../../redux/slice/sketchSlice";
import { setImageUploadStatus, setNewImageUploadStatus } from "../../../../redux/slice/stepSlice";
import { run as runpodRun } from "../../../../services/runpodService";
import { processImageForRun } from "../../../../util/imageCropUploadUtils";

export const processSketchJob = async ({
  images,
  uploadToBackend,
  batchId,
  onCoverReady,
  onImageComplete,
  onError = () => {},
  shouldRegenerate = false,
  bookId = null, // to know which book it belongs to
}) => {
  const { dispatch } = store;
  if (images.length === 0) {
    toast.error("Please upload at least one image to continue.");
    return;
  }

  try {
    console.log(`🔄 Starting regeneration for ${images.length} images via backend...`);

    // Prepare images (auto-crop and upload to Cloudinary if needed)
    const processedImages = await Promise.all(
      images.map(async (img, i) => {
        try {
          if (!!img?._id) {
            dispatch(setImageUploadStatus({ type: 'add', id: img._id }));
          } else if (!img?.isEditable) {
            dispatch(setNewImageUploadStatus({ type: 'add', id: img.id }));
          }

          const result = await processImageForRun(img);
          if (!result) return null;
          if (typeof result === 'string') {
            return { url: result };
          }
          return {
            url: result.url,
            ...(result.mediaId && { mediaId: result.mediaId }),
            ...(result.oldPublicId && { oldPublicId: result.oldPublicId }),
          };
        } catch (err) {
          console.error(`Error processing image ${i}:`, err);
          return null;
        }
      })
    );

    const imageUrls = processedImages.filter((row) => row && row.url);

    if (imageUrls.length === 0) {
      throw new Error("Failed to process any images for regeneration.");
    }

    // Line art only: do not send `title` or RunPod treats the job as cover workflow.
    const response = await runpodRun({
      imageUrls,
      bookId: bookId,
    });

    if (!response?.success) {
      throw new Error(response?.message || "Failed to start regeneration job on backend.");
    }

    console.log("✅ Regeneration job started successfully:", response.data);
    
    // UI updates and polling are now handled by Sockets in ReviewBookContent.js
    // We can mark "all set" for the trigger part
    dispatch(setAllCompleted(false)); // Reset completed state so progress bar shows

  } catch (err) {
    console.error("Sketch Regeneration Error:", err);
    toast.error(err.message || 'Failed to start regeneration process.');
    
    // Cleanup if possible
    images.forEach(img => {
      if (img?._id) {
        dispatch(setImageUploadStatus({ type: 'remove', id: img._id }));
      }
      if (img?.id) {
        dispatch(setNewImageUploadStatus({ type: 'remove', id: img.id }));
      }
    });

    onError();
  }
};
